import { Plus } from 'lucide-react';
import { useT } from '@/i18n/LocaleProvider';
import type { IAccessRead } from '@/utils/workAreaPermissionGate';
import { gateControlProps } from '@/utils/gateControl';
import { heldGate } from '@/utils/workAreaPermissionGate';

/**
 * "New page", beside Home in the sidebar. Gated on `work_area.manage`, and ⛔ never hidden for a
 * member who lacks it: a create they may not make is drawn disabled, its reason the one-line
 * tooltip. A guest reader of the work area meets it only where their grants let them manage pages
 * (PX-18, D-0432 b; `Layout` leaves it out otherwise), whatever they hold elsewhere.
 */
export function SidebarNewPageButton({
  manageAnswer,
  manageRead,
  phone,
  onOpen,
}: {
  /** `dashboardPageStore.manageAnswer`: held, refused, or `undefined` while unanswered. */
  manageAnswer: boolean | undefined;
  manageRead: IAccessRead;
  phone: boolean;
  onOpen: () => void;
}) {
  const t = useT();
  const label = t('navigation.newPage');
  return (
    <button
      type="button"
      aria-label={label}
      onClick={onOpen}
      {...gateControlProps(heldGate(manageAnswer, 'work_area.manage', manageRead), {
        title: label,
      })}
      className={`grid shrink-0 place-items-center rounded-md text-gray-400 outline-none hover:bg-[#D7DBDC]/50 hover:text-gray-900 focus-visible:ring-2 focus-visible:ring-focus dark:hover:bg-[#242424] dark:hover:text-white ${
        phone ? 'h-touch w-touch' : 'h-7 w-7'
      }`}
    >
      <Plus className={phone ? 'h-4 w-4' : 'h-3.5 w-3.5'} />
    </button>
  );
}
